import styled from '@emotion/styled'
import {NoStyleButton} from '@vio/atlas/helpers/NoStyleButton'

export const ExperimentId = styled('div')`
  padding: 10px 5px;
  width: 100%;
  font-size: 0.9em;
`

export const ActionIconWrapper = styled(NoStyleButton)`
  display: inline-block;
  flex: 0 0 35px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const RowWrapper = styled('div')`
  display: flex;
  align-items: center;
  margin: 5px 0;
  width: 100%;
`

export const ExperimentWrapper = styled('div')<{
  variant?: 'forced' | 'received'
}>`
  background-color: ${({variant}) =>
    variant == 'forced' ? '#d4d4d4' : '#fbfbfb'};
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  width: 100%;
  line-height: 1.2em;
  border: 1px solid #d4d4d4;
  border-radius: 5px;
  overflow: hidden;
`

export const statusColorMap = {
  a: '#82b74b',
  b: '#c94c4c',
  auto: '#888'
}

export type StatusColorMapType = keyof typeof statusColorMap

export const StatusBadge = styled('span')<{
  status: StatusColorMapType
}>`
  flex: 0 0 50px;
  padding: 10px 0;
  align-items: center;
  text-align: center;
  color: white;
  background-color: ${({status}) => statusColorMap[status]};
  text-transform: uppercase;
`

export const InputRowWrapper = styled('div')`
  width: 100%;
  display: flex;
  gap: 10px;
`

export const InputWrapper = styled('div')`
  width: 100%;
`
